import { useIntl } from "react-intl";

export const useTranslatedSteps = (stepCount) => {
  const intl = useIntl();
  return Array.from({ length: stepCount }, (_, index) => index + 1).map((value) =>
    intl.formatMessage(
      {
        id: "shared-ui: stepper_progress step of total",
        description: "Describes the current step number in a workflow",
        defaultMessage: "Step {value} of {total}",
      },
      { value, total: stepCount }
    )
  );
};
